import { Box, Link } from '@material-ui/core';

import FooterStyles from 'common/components/footer/footer-styles';
import { translate } from 'common/config/i18n';

const Footer = () => {
  const classes = FooterStyles();
  return (
    <Box className={classes.footer}>
      <Link className="link" href="https://astropay.com/pp-europe/?lang=en" target="_blank">
        {translate('one_touch_privacy_policy')}
      </Link>
    </Box>
  );
};

export default Footer;
